import { AdminDetailGrid } from '@/components/patterns/admin-page'
import { Can } from '@/lib/casl'
import { cn } from '@/lib/utils'
import SaveBar from './SaveBar'
import { PriceAdjustmentDetailsSection } from './ProductPriceAdjustmentFormParts/DetailsSection'
import { PriceAdjustmentFormDialogs } from './ProductPriceAdjustmentFormParts/Dialogs'
import { PriceAdjustmentScheduleSection } from './ProductPriceAdjustmentFormParts/ScheduleSection'
import { PriceAdjustmentSummaryCard } from './ProductPriceAdjustmentFormParts/SummaryCard'
import { getScheduleEndDateMin as getPriceAdjustmentEndDateMin } from './ScheduleAutomationFields'
import { getPriceAdjustmentScheduleBounds } from './ProductPriceAdjustmentFormParts/helpers'
import { useProductPriceAdjustmentFormController } from './ProductPriceAdjustmentFormParts/useProductPriceAdjustmentFormController'

const ProductPriceAdjustmentForm = (props) => {
  const controller = useProductPriceAdjustmentFormController(props)
  const { form, handleSave, initialData, mutation, showPageTreatment } = controller
  const useSideStatus = showPageTreatment && initialData

  return (
    <div className={cn('w-full', useSideStatus ? 'max-w-none' : 'max-w-4xl')}>
      <form.AppForm>
        <form.Form>
          {useSideStatus ? (
            <AdminDetailGrid
              className="gap-6"
              asideClassName="gap-6 lg:grid-cols-1 xl:space-y-6"
              asideFirstOnStack
              main={
                <>
                  <PriceAdjustmentDetailsSection controller={controller} />
                  <PriceAdjustmentScheduleSection controller={controller} />
                </>
              }
              aside={<PriceAdjustmentSummaryCard controller={controller} placement="side" />}
            />
          ) : (
            <div className="grid gap-y-6">
              <PriceAdjustmentSummaryCard controller={controller} />
              <PriceAdjustmentDetailsSection controller={controller} />
              <PriceAdjustmentScheduleSection controller={controller} />
            </div>
          )}

          <Can do="edit" on="products">
            <SaveBar mutation={mutation} onSave={handleSave} />
          </Can>
        </form.Form>
      </form.AppForm>

      <PriceAdjustmentFormDialogs controller={controller} />
    </div>
  )
}

export { getPriceAdjustmentEndDateMin, getPriceAdjustmentScheduleBounds }

export default ProductPriceAdjustmentForm
